// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__fU5ye","copyright":"Footer_copyright__WAIeC","socials":"Footer_socials__C+zaw"};